import * as tslib_1 from "tslib";
import { BaseManager } from "./base.manager";
import { LocalStorageRepositoryInterface } from "../../datastore/local/localstorage.interface";
import { LogRepositoryInterface } from "../../datastore/repositories/log/log.interface";
var LogManager = /** @class */ (function (_super) {
    tslib_1.__extends(LogManager, _super);
    function LogManager(localStorageRepository, logRepository) {
        var _this = _super.call(this, localStorageRepository) || this;
        _this.localStorageRepository = localStorageRepository;
        _this.logRepository = logRepository;
        return _this;
    }
    /* eslint-disable camelcase, @typescript-eslint/camelcase */
    LogManager.prototype.addEvent = function (targetUUID, tag) {
        return this.logRepository.addEvent({
            actor_uuid: this.localStorageRepository.getLoggedUserId(),
            target_uuid: targetUUID,
            tag: tag
        });
    };
    LogManager.prototype.getLogs = function (size, page) {
        return this.logRepository.getLogs(size, page);
    };
    return LogManager;
}(BaseManager));
export { LogManager };
